import clsx from 'clsx';
import { Toaster as SonnerToaster } from 'sonner';
import styles from './Toaster.module.css';

const TOAST_DURATION_MS = 4_500;

/** Mount once at the root; messages are sent with `notify`. */
export const Toaster = () => (
  <SonnerToaster
    theme="dark"
    position="bottom-center"
    duration={TOAST_DURATION_MS}
    visibleToasts={3}
    offset={{ bottom: 'calc(var(--space-6) + var(--safe-bottom))' }}
    mobileOffset={{ bottom: 'calc(var(--bottom-nav-height) + var(--space-4) + var(--safe-bottom))' }}
    toastOptions={{
      unstyled: true,
      classNames: {
        toast: clsx(styles.toast),
        title: clsx(styles.title),
        description: clsx(styles.description),
        icon: clsx(styles.icon),
        success: clsx(styles.success),
        error: clsx(styles.error),
        actionButton: clsx(styles.action),
      },
    }}
  />
);
